import { Translatable } from "@icc/shared/helpers";

export class RollerCover {
    id: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Nazwa */
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Opis */
    description: string;
    /** Typ osłony */
    type: 'blind_box';
    /** Zdjęcie */
    img: string;
    printCode: string;
    /** Zestaw grup kolorów */
    colorGroupSetId: number;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Waga */
    weight: number;
    /** Wysokość skrzynki (rozmiar) */
    height: number;
    /** Głębokość skrzynki */
    depth?: number;
    /** Maksymalna długość */
    maxLength?: number;
    /** Dostępne wyjścia taśmy/linki */
    availableTapeCordOutputs?: number[] | string;
    /** Domyślne wyjście taśmy/linki */
    defaultTapeCordOutput?: number;
    /** Wymagana listwa tynkowa zewnętrzna */
    requiredExternalPlasterStrip?: boolean;
    /** Dolne wysunięcie skrzynki [mm] */
    bottomBoxExtension?: number;
    /** Brak ryflowania pomimo zabudowy */
    noGrooving?: boolean;
    /** Czy skrzynka jest domyślna (wybrana automatycznie) */
    isDefault?: boolean;
    /** Odległość klapy rewizyjnej od górnej krawędzi skrzynki [mm] */
    inspectionHatchDistanceFromTop?: number;
    /** Domyślne umiejscowienie klapy rewizyjnej */
    defaultInspectionHatchLocation?: 'front' | 'bottom' | 'other';
}
